const Footer = () => (
  <footer id="sticky-footer" className="py-4 mt-5 bg-dark text-white-50">
    <div className="text-center">
      <small>Copyright &copy; New Wave Festival 2019</small>
    </div>
  </footer>
);

export default Footer;